module.exports = __webpack_public_path__ + "static/cristina-jones-aada4355e421f58c9153dcb37c86a2c2.png";